import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight, BadgePercent } from "lucide-react";
import { WEB_PACKAGES } from "@/data/pricing";
import { API } from "@/lib/publicSettings";

export const PromoBanner = () => {
  const [promos, setPromos] = useState([]);
  useEffect(() => { axios.get(`${API}/public/promotions`).then((r) => setPromos(r.data)).catch(() => {}); }, []);
  if (!promos.length) return null;
  return (
    <div className="wrap relative z-20 mt-6 space-y-3">
      {promos.map((p) => (
        <div key={p.id} data-testid={`promo-${p.id}`} className="anim-in flex flex-col gap-4 rounded-2xl border border-blue-200 bg-gradient-to-r from-[#EAF4FF] to-[#EEE8FF] p-5 text-slate-900 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex gap-3">
            <BadgePercent className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" />
            <div>
              <p className="font-display text-lg font-bold">{p.title}{p.price && <span className="ml-2 text-blue-700">{p.price}</span>}</p>
              {p.description && <p className="text-sm text-slate-700">{p.description}</p>}
              <p className="mt-1 text-xs text-slate-600">{[p.conditions, p.valid_to && `Valida fino al ${new Date(p.valid_to).toLocaleDateString("it-IT")}`].filter(Boolean).join(" · ")}</p>
            </div>
          </div>
          <Link to={`/preventivo-gratuito${p.package_id ? `?pacchetto=${p.package_id}` : ""}`} data-testid={`promo-cta-${p.id}`} className="btn-primary shrink-0">{p.cta_label || "Richiedi l’offerta"}</Link>
        </div>
      ))}
    </div>
  );
};

export default function PriceStrip() {
  return (
    <section aria-label="Prezzi d’ingresso" className="relative z-10 bg-slate-50 pb-4">
      <PromoBanner />
      <div className="wrap -mt-0 pt-6">
        <div className="snap-row lg:grid lg:grid-cols-4 lg:overflow-visible">
          {WEB_PACKAGES.map((p) => (
            <Link key={p.id} to={`/preventivo-gratuito?pacchetto=${p.id}`} data-testid={`strip-package-${p.id}`}
              className={`lift group w-[78%] rounded-2xl border p-5 sm:w-[46%] lg:w-auto ${p.featured ? "border-blue-600 bg-blue-600 text-white" : "border-slate-200 bg-white"}`}>
              <div className="flex items-center justify-between">
                <p className={`text-xs font-semibold uppercase tracking-[0.16em] ${p.featured ? "text-blue-100" : "text-slate-500"}`}>{p.name}</p>
                {p.featured && <span className="rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-blue-700">Più scelto</span>}
              </div>
              <p className={`mt-3 font-display text-2xl font-extrabold ${p.featured ? "text-white" : "text-slate-900"}`}>{p.setup.startsWith("Nessun") ? p.monthly : p.setup}</p>
              <p className={`text-sm ${p.featured ? "text-blue-100" : "text-slate-500"}`}>{p.setup.startsWith("Nessun") ? "senza costo iniziale · 12 mesi" : `+ ${p.monthly}`}</p>
              <p className={`mt-3 flex items-center justify-between text-sm font-semibold ${p.featured ? "text-white" : "text-slate-900"}`}>{p.headline}<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></p>
            </Link>
          ))}
        </div>
        <p className="mt-2 text-xs text-slate-500">Prezzi IVA esclusa · canoni disdicibili con 30 giorni di preavviso (Digital Partner: primo anno)</p>
      </div>
    </section>
  );
}
